import { ReservationState } from '../enums/types';
import type { MewsReservation } from '../interfaces';

export const isDesynchronized = (reservation: MewsReservation): boolean => {
  const missingInternalReservationIds =
    (!reservation.InternalReservation ||
      !reservation.InternalReservation.conversationCreated) &&
    (reservation.State === ReservationState.CONFIRMED ||
      reservation.State === ReservationState.STARTED);

  return missingInternalReservationIds;
};
